export default __webpack_public_path__ + "2008 Magnetic-field-induced interference of scattering states in ultracold collisions.pdf";